import React from 'react';
import FuseSuspense from '@fuse/core/FuseSuspense';
import { Route } from 'react-router-dom';

// Function to map the navigationConfig to Route components
function renderRoutes(routes) {
  return routes.map((route, index) => {
    // recursive sub-routes
    if (route?.children) {
      return (
        <Route
          key={`subroute-${index}`}
          path={route.path}
          element={
            <FuseSuspense>
              {route.component ? (
                <route.component routes={route.children} />
              ) : (
                <route.element routes={route.children} />
              )}
            </FuseSuspense>
          }
        >
          {renderRoutes(route.children)}
        </Route>
      );
    }

    // route
    return (
      <Route
        key={`route-${index}`}
        path={route.path}
        element={
          <FuseSuspense>
            {route.component ? <route.component /> : <route.element />}
          </FuseSuspense>
        }
      />
    );
  });
}

export default renderRoutes;
